import t from 'tcomb-form';


function withMrProper(origRes, cleaner) {
    function Irreducible(value) {
        return origRes(cleaner(value));
    }

    // Make the result look like a real Irreducible
    Irreducible.meta = origRes.meta;
    Irreducible.displayName = origRes.name;

    // Rewire the .is method to apply cleaning to the value
    Irreducible.is = function (value) {
        return origRes.is(cleaner(value));
    };

    return Irreducible;
}


export default function cleanedType(name, oType, clean_function) {
    return withMrProper(t.irreducible(name, oType.is), clean_function);
}



/** WEBPACK FOOTER **
 ** ./app/src/forms/validators/clean.js
 **/